import { Link } from 'react-router'

import { DisplayDate } from 'js/components/DisplayDate'
import Text from 'js/components/Text/Text'
import TiptapView from 'js/components/Tiptap/TiptapView'

import styles from './PodcastEpisodes.module.css'

const PodcastEpisodes = ({ episodes }) => (
    <ul className={styles.wrapperListView}>
        {episodes.map(({ guid, timePublished, url, title, excerpt }) => (
            <li key={guid}>
                <Text variant="grey" size="small">
                    <DisplayDate
                        date={timePublished}
                        type="timeSince"
                        side="right"
                    />
                </Text>

                <Link to={url} className={styles.episodeTitle}>
                    {title}
                </Link>

                <TiptapView content={excerpt} contentType="html" />
            </li>
        ))}
    </ul>
)

export default PodcastEpisodes
